import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/** Selects the redesigned Company Configuration experience. */
export function useCompanyConfigRedesignEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableCompanyConfigRedesign);
}

/** Selects the redesigned Bulk Create Companies experience. */
export function useBulkCreateCompanyRedesignEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableBulkCreateCompanyRedesign);
}
